import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SelectionOptions } from 'coreOld/enums';
import { GetManyCountResponse } from 'coreOld/types';

interface IState {
  selectedRow: unknown | null;
  selectionMode: SelectionOptions | null;
  filteredCount: GetManyCountResponse | null;
  totalCount: GetManyCountResponse | null;
}

const initialState: IState = {
  selectedRow: null,
  selectionMode: null,
  filteredCount: null,
  totalCount: null,
};

const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    setSelectedRow: (state, action: PayloadAction<any>) => {
      state.selectedRow = action.payload;
    },
    setSelectionMode: (state, action: PayloadAction<SelectionOptions>) => {
      state.selectionMode = action.payload;
    },
    setFilteredCount: (state, action: PayloadAction<GetManyCountResponse>) => {
      state.filteredCount = action.payload;
    },
    setTotalCount: (state, action: PayloadAction<GetManyCountResponse>) => {
      state.totalCount = action.payload;
    },
    cleanState: () => initialState,
  },
});

export const { cleanState, setFilteredCount, setTotalCount, setSelectedRow, setSelectionMode } =
  tableSlice.actions;

export const tableReducer = tableSlice.reducer;
